import {
  PlaneDepartureIcon,
  PlaneArrivalIcon,
  HomeStatusIcon,
  GuestIcon,
  HouseCheckIcon,
  ChartReportIcon,
  EmptyBedIcon,
} from "components/Icons";
import HouseStatus from "./house/HouseStatus";
import CheckOut from "./check_out/CheckOut";
import CheckIn from "./check_in/CheckIn";
import Presents from "./presents/Presents";
import Folios from "./folios/Folios";
import Guests from "./guests/Guests";
import Reports from "./reports/Reports";

const style = "flex my-auto fill-current mx-auto mb-1 max-md:h-8";

function nextFeature() {
  return (
    <h3 className="text-xl text-blue-500 font-bold mt-12">
      Pronto estará disponible esta sección, no te desesperes !!! 😎
    </h3>
  );
}

const tabs = {
  house_status: {
    id: "house_status",
    name: "House Status",
    Component: HouseStatus,
    Icon: <HomeStatusIcon className={style} />,
  },
  check_out: {
    id: "check_out",
    name: "Check-Out",
    Component: CheckOut,
    Icon: <PlaneDepartureIcon className={style} />,
  },
  check_in: {
    id: "check_in",
    name: "Check-In",
    Component: CheckIn,
    Icon: <PlaneArrivalIcon className={style} />,
  },
  presents: {
    id: "presents",
    name: "Presents",
    Component: Presents,
    Icon: <HouseCheckIcon className={style} />,
  },
  guests: {
    id: "guests",
    name: "Guests",
    Component: Guests,
    Icon: <GuestIcon className={style} />,
  },
  folios: {
    id: "folios",
    name: "Folios",
    Component: Folios,
    Icon: <EmptyBedIcon className={style} />,
  },
  reports: {
    id: "reports",
    name: "Reports",
    Component: Reports,
    Icon: <ChartReportIcon className={style} />,
  },
};

export { tabs };
